import React from 'react';
interface CTAButtonProps {
  text: string;
  className?: string;
  /** If provided, the button becomes a link that navigates to this URL (e.g. the checkout). */
  href?: string;
}
const baseClasses = 'bg-brightGreen hover:bg-green-400 text-ink font-bold py-4 px-8 rounded-lg text-xl md:text-2xl transition-colors duration-200 flex items-center justify-center gap-2 w-full md:w-auto';
export function CTAButton({
  text,
  className = '',
  href
}: CTAButtonProps) {
  // When an href is provided, render a real anchor so the redirect works reliably
  // (including inside preview iframes) and stays accessible/keyboard-navigable.
  if (href) {
    const handleCheckoutClick = () => {
      if (typeof window !== 'undefined' && (window as any).fbq) {
        ;
        (window as any).fbq('track', 'InitiateCheckout');
      }
    };
    return <a href={href} onClick={handleCheckoutClick} className={`${baseClasses} ${className} no-underline`} data-id="element-69">
        {text}
      </a>;
  }
  // Default behavior: smooth-scroll to the pricing section.
  const handleScroll = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <button onClick={handleScroll} className={`${baseClasses} ${className}`} data-id="element-70">
      {text}
    </button>;
}